import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import Article from './ui/Article.js'
import Section from './ui/Section.js'
import Paragraphs from './ui/Paragraphs.js'
import Code from './ui/Code.js'

class Method extends Component {
    render() {
        const method = this.props.definition;
        return (
            <div className="mb-3">
                <div className="mb-1"><h4 className="m-0">{method.name}</h4></div>
                <div className="mb-1">
                    <pre>rpc {method.name}(<Link to={method.requestFullType}>{method.requestType}</Link>) returns (<Link to={method.responseFullType}>{method.responseType}</Link>)</pre>
                </div>
                <div>{method.description}</div>
            </div>
        );
    }
}

class Service extends Component {

    render() {
        return (
            <Article kind="Service" title={this.props.descriptor.name} subtitle={this.props.descriptor.summary}>
                {this.props.descriptor.description &&
                    <Section title="Overview">
                        <Paragraphs text={this.props.descriptor.description} />
                    </Section>
                }
                <Section title="Fully Qualified Name">
                    <Code>{this.props.descriptor.fullName}</Code>
                </Section>
                <Section title="Methods">
                    { this.props.descriptor.methods.map((method) => (
                        <Method definition={method} />
                    )) }
                </Section>
            </Article>
        );
    }
}

export default Service;



// WEBPACK FOOTER //
// ./src/reference/Service.js